import React, { Component } from 'react';
import { Tabs } from 'antd'
import { BaseRequest } from 'models/request/BaseRequest';
import { AgentsTeamManagement, DeskAdminConfigs, DeskMonitoring, DeskRules, Distribution, TicketInformation } from './Index';

const { TabPane } = Tabs

export class Desk extends Component<BaseRequest> {

  render() {
    return (
      <div>
        <Tabs defaultActiveKey="Distribution">
          <TabPane tab="Distribution" key="Distribution">
            <Distribution BotIdentifier={this.props.BotIdentifier} ClusterName={this.props.ClusterName} MetaData={null}></Distribution>
          </TabPane>
          <TabPane tab="Monitoring" key="Monitoring">
            <DeskMonitoring BotIdentifier={this.props.BotIdentifier} ClusterName={this.props.ClusterName} MetaData={null}></DeskMonitoring>
          </TabPane>
          <TabPane tab="Ticket Information" key="TicketInformation">
            <TicketInformation BotIdentifier={this.props.BotIdentifier} ClusterName={this.props.ClusterName} MetaData={null}></TicketInformation>
          </TabPane>
          <TabPane tab="Agents Team Management" key="AgentsTeamManagement">
            <AgentsTeamManagement BotIdentifier={this.props.BotIdentifier} ClusterName={this.props.ClusterName} MetaData={null}></AgentsTeamManagement>
          </TabPane>
          <TabPane tab="Rules" key="DeskRules">
            <DeskRules BotIdentifier={this.props.BotIdentifier} ClusterName={this.props.ClusterName} MetaData={null}></DeskRules>
          </TabPane>
          <TabPane tab="Agent Domains Allowed" key="DeskConfigs">
            <DeskAdminConfigs BotIdentifier={this.props.BotIdentifier} ClusterName={this.props.ClusterName} MetaData={null}></DeskAdminConfigs>
          </TabPane>
        </Tabs>
      </div>
    )
  }
}